const API_BASE_HOST =
  window.location.hostname !== 'localhost' ? 'https://greengatehobbies.com' : 'http://localhost:3000';

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    console.log('[GGH] On load');

    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });

    this.validateInitialCart();
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  validateInitialCart() {
    if (window.cartData && window.cartData.items) {
      console.log('[GGH] Using window.cartData for initial validation');
      this.validateCartWithBackend(window.cartData);
      return;
    }

    this.fetchAndValidateCart();
  }

  fetchAndValidateCart() {
    const isDebugMode = window.location.hostname === 'localhost' || window.location.search.includes('debug=true');

    if (isDebugMode) {
      console.log('[GGH] Fetching cart data for validation');
    }

    this.enableCheckoutButtons();

    fetch(`${routes.cart_url}.js`)
      .then((response) => {
        if (!response.ok) {
          if (isDebugMode) {
            console.warn(`[GGH] Cart fetch failed with status: ${response.status}. Allowing checkout to proceed.`);
          }
          return null;
        }
        return response.json();
      })
      .then((cartData) => {
        if (cartData === null) {
          return;
        }

        if (!cartData || !cartData.items) {
          if (isDebugMode) {
            console.log('[GGH] Cart data is empty or invalid. Allowing checkout to proceed.');
          }
          return;
        }

        if (isDebugMode) {
          console.log('[GGH] Got cart data for validation');
        }

        this.validateCartWithBackend(cartData);
      })
      .catch((e) => {
        console.error('[GGH] Error fetching cart data:', e);
        this.enableCheckoutButtons();
      });
  }

  enableCheckoutButtons() {
    const checkoutButtons = document.querySelectorAll('[name="checkout"]');
    const cartErrorElement = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');

    if (cartErrorElement) {
      cartErrorElement.textContent = '';
    }

    let isCartEmpty = true;

    const cartItemElements = document.querySelectorAll('.cart-item');
    if (cartItemElements && cartItemElements.length > 0) {
      isCartEmpty = false;
    }

    checkoutButtons.forEach((button) => {
      if (!isCartEmpty) {
        button.removeAttribute('disabled');
      } else {
        button.setAttribute('disabled', 'disabled');
      }
    });
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId,
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }

          this.validateAfterCartUpdate();
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;

          this.validateAfterCartUpdate();
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  validateAfterCartUpdate() {
    this.fetchAndValidateCart();
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector,
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });

        if (window.__gghRefreshCart) window.__gghRefreshCart();

        this.validateCartWithBackend(parsedState);
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        console.log('[GGH] On update');
        this.disableLoading(line);
      });
  }

  validateCartWithBackend(cartData) {
    const isDebugMode = window.location.hostname === 'localhost' || window.location.search.includes('debug=true');
    if (isDebugMode) {
      console.log('[GGH] Validating cart with backend');
    }

    const cartErrorElement = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');

    if (!cartData || !cartData.items || cartData.items.length === 0) {
      this.enableCheckoutButtons();
      return;
    }

    this.enableCheckoutButtons();

    if (cartData.items.length > 0 && isDebugMode) {
      console.log('[GGH] Cart item structure sample:', cartData.items[0]);
    }

    const cartItems = cartData.items.map((item) => {
      const itemData = {
        quantity: item.quantity,
      };

      if (item.product_id) itemData.product_id = item.product_id;
      if (item.variant_id) itemData.variant_id = item.variant_id;
      if (item.id) itemData.line_item_id = item.id;
      if (item.handle) itemData.handle = item.handle;
      if (item.key) itemData.key = item.key;
      if (item.sku) itemData.sku = item.sku;
      if (item.gid) itemData.gid = item.gid;

      if (item.title) itemData.title = item.title;
      if (item.product_title) itemData.product_title = item.product_title;

      return itemData;
    });

    if (isDebugMode) {
      console.log('[GGH] Sending cart data to backend:', cartItems);
    }

    fetch(`${API_BASE_HOST}/validate_cart`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({ cart_items: cartItems }),
    })
      .then((response) => {
        if (!response.ok) {
          if (isDebugMode) {
            console.warn(`[GGH] Validation request returned status: ${response.status}. Allowing checkout to proceed.`);
          }
          return null;
        }
        return response.json();
      })
      .then((data) => {
        if (data === null) return;

        if (isDebugMode) {
          console.log('[GGH] Backend validation response:', data);
        }

        if (data.valid === false) {
          const checkoutButtons = document.querySelectorAll('[name="checkout"]');
          checkoutButtons.forEach((button) => {
            button.setAttribute('disabled', 'disabled');
          });

          if (cartErrorElement && data.message) {
            cartErrorElement.textContent = data.message;
          }
        }
      })
      .catch((error) => {
        console.error('[GGH] Cart validation error:', error);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    if (cartStatus) {
      cartStatus.setAttribute('aria-hidden', false);
      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', true);
      }, 1000);
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER),
        );
      }
    },
  );
}
